import type { EditPortfolioCommandData } from '@festina/unitlink-general-types/unitlink'
import { FormikForm } from '@festina-life/ui/formikForms'

import type { CommandDataFormProps } from '../../commandActions/CommandDataFormAndSimulation'
import { EditPortfolioCommandDataFields } from './EditPortfolioCommandDataFields'

export function EditPortfolioForm(
  props: CommandDataFormProps<EditPortfolioCommandData>,
) {
  return (
    <FormikForm
      initialValues={
        {
          _type: 'EditPortfolioCommandData',
          subPortfolioEdits: [
            // Command makes no sense without edits. So we can show the user one by default.
            {
              _type: 'SubPortfolioEdit',
              editType: 'update',
              subPortfolio: { _type: 'SubPortfolio' },
            },
          ],
        } satisfies EditPortfolioCommandData
      }
      {...props}
    >
      <EditPortfolioCommandDataFields />
    </FormikForm>
  )
}
